import React from "react";
import PropTypes from "prop-types";
import ProductTile from "../ProductTile";
import ProductImage from "../ProductTile/ProductImage";
import LazyProductImage from "../../containers/LazyProductImage";
import config from "../../config/common";
import styles from "./ListingPage.css";

const initialImageLoadCount = 4;

const getFocusTileIndex = ({ focusFirstTile, focusLastTile, products }) =>
  focusFirstTile ? 0 : focusLastTile ? products.length - 1 : null;

const ListingPage = ({
  isInitialPage,
  page: { products, pageNumber },
  focusFirstTile,
  focusLastTile,
  advert
}) => {
  const focusTileIndex = getFocusTileIndex({
    focusFirstTile,
    focusLastTile,
    products
  });

  let items = products.map(({ product }, index) => (
    <ProductTile
      {...product}
      key={product.id}
      pageNumber={pageNumber}
      focusOnMount={index === focusTileIndex}
      ProductImageComponent={
        isInitialPage && index < initialImageLoadCount
          ? ProductImage
          : LazyProductImage
      }
    />
  ));

  if (pageNumber === 1 && advert) {
    const {
      adverts: { adPosition }
    } = config;
    items = [
      ...items.slice(0, adPosition),
      <React.Fragment key="advert">
        {advert({ className: styles.advert })}
      </React.Fragment>,
      ...items.slice(adPosition)
    ];
  }

  return (
    <section className={styles.listingPage} data-auto-id={pageNumber}>
      {items}
    </section>
  );
};

ListingPage.propTypes = {
  isInitialPage: PropTypes.bool.isRequired,
  page: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    pageNumber: PropTypes.number
  }),
  focusFirstTile: PropTypes.bool.isRequired,
  focusLastTile: PropTypes.bool.isRequired,
  advert: PropTypes.func
};

export default ListingPage;
